import { Component } from '@angular/core';
import {
  BaseComponent
} from 'base-form';

@Component({
  selector: 'mfpc-select-show-mode',
  templateUrl: './select-show-mode.component.html',
  styleUrls: ['./select-show-mode.component.scss']
})
export class SelectShowModeComponent extends BaseComponent {}
